import * as React from "react";

import { cn } from "../../lib/utils";

type MessageProps = React.HTMLAttributes<HTMLDivElement> & {
  from: "user" | "assistant" | "system";
};

const Message = React.forwardRef<HTMLDivElement, MessageProps>(({ className, from, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex w-full", from === "user" ? "justify-end" : "justify-start", className)}
    data-from={from}
    {...props}
  />
));
Message.displayName = "Message";

const MessageContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "max-w-[min(82%,760px)] rounded-3xl border border-gray-200 bg-white px-4 py-3 text-sm leading-6 text-gray-900 shadow-sm",
        className,
      )}
      {...props}
    />
  ),
);
MessageContent.displayName = "MessageContent";

// Typografię odpowiedzi trzyma `chat-typeset.css` (aplikacja importuje go raz, globalnie);
// gęstość ustawia kontener przez `data-chat-density`.
const MessageResponse = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn("chat-typeset", className)} {...props} />,
);
MessageResponse.displayName = "MessageResponse";

const MessageActions = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("mt-2 flex items-center gap-1 text-gray-500", className)} {...props} />
  ),
);
MessageActions.displayName = "MessageActions";

type MessageActionProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: string;
};

const MessageAction = React.forwardRef<HTMLButtonElement, MessageActionProps>(
  ({ className, children, label, title, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      title={title ?? label}
      className={cn(
        "inline-flex h-7 w-7 items-center justify-center rounded-md transition-colors hover:bg-gray-100 hover:text-gray-950 disabled:pointer-events-none disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  ),
);
MessageAction.displayName = "MessageAction";

export { Message, MessageAction, MessageActions, MessageContent, MessageResponse };
